import APIDOC from '@/common/serverApi';
import {post, get} from '@/common/request';
/*
* 仓库：课程对应的人脸识别权限
* */
export default {
    namespaced: true,
    state: {
        /*item=>
{
    "courseSettingId": "1676492493547544576",
    "courseId": "5940",
    "courseFaceSwitch": 1,
    "coursePhotoIntervalTime": 5,
    "courseSkipTimes": 5,
    "courseFaceScore": 5,
    "coursePhotoCount": 5,
    "jobPhotoIntervalTime": 5,
    "jobSkipTimes": 5,
    "jobFaceScore": 5,
    "jobPhotoCount": 5,
    "examPhotoIntervalTime": 5,
    "examSkipTimes": 5,
    "examFaceScore": 5,
    "examPhotoCount": 5,
    "makeupExamPhotoIntervalTime": 5,
    "makeupExamSkipTimes": 5,
    "makeupExamFaceScore": 5,
    "makeupExamPhotoCount": 5
}
* */
        course_faceAuth_map: [],
    },
    getters: {
        getAll(store) {
            return store.course_faceAuth_map;
        }
    },
    mutations: {
        add(store, payload) {
            const _validate = (payload) => {
                const courseId = payload.courseId;
                const arr = store.course_faceAuth_map;
                const item = arr.find(item => item.courseId === courseId);
                return item != null && Object.keys(item).length === 0 || !item;
            }
            const bool = _validate(payload);
            if (bool) {
                store.course_faceAuth_map.push(payload);
                return true;
            }
            return false;
        },
        findItem(store, courseId) {
            return store.course_faceAuth_map.find(item => item.courseId === courseId);
        }
    },
    actions: {}
}





// WEBPACK FOOTER //
// ./src/store/faceRecognition.js